<script>
    import { onMount } from "svelte";
    import Overlay from "./overlay.svelte";
    import {Html5QrcodeScanner, Html5QrcodeScanType} from 'html5-qrcode'
    import { code } from "../store";
    import { t } from "../i18n/i18n";

    export let open;
    var html5QrcodeScanner;
    const config = {
        fps: 30,
        qrbox: 200,
        rememberLastUsedCamera: true,
        supportedScanTypes: [Html5QrcodeScanType.SCAN_TYPE_CAMERA],
        videoConstraints: {facingMode: {ideal: 'environment'}}
    }

    const close = () => {
        open = false
    }

    onMount(async()=>{
        if(localStorage.getItem('HTML5_QRCODE_DATA') == null){
            let json = { "hasPermission": true, "lastUsedCameraId": null }
            localStorage.setItem('HTML5_QRCODE_DATA', JSON.stringify(json));
        }
    })

    const check_reader_set = (_open) => {
        if(document.getElementById('reader') == null) return;
        if(_open == true){
            if(document.getElementById('reader').hasChildNodes()){
                document.getElementById('html5-qrcode-button-camera-start').click();
            }else{
                navigator.mediaDevices.getUserMedia({ audio: false, video: true })
                .then((stream) => {
                    let tracks = stream.getTracks();
                    tracks.forEach(track => track.stop());
                    
                    html5QrcodeScanner = new Html5QrcodeScanner("reader", config);
                    html5QrcodeScanner.render(onScanSuccess);

                    document.getElementById('qrcode-hint-no-video').innerHTML = '加載中...';

                    let json = {};
                    if(localStorage.getItem('HTML5_QRCODE_DATA') != null){
                        json = JSON.parse(localStorage.getItem('HTML5_QRCODE_DATA'));
                        json.hasPermission = true;
                    }
                    localStorage.setItem('HTML5_QRCODE_DATA', JSON.stringify(json));
                })
                .catch(error => {
                    console.log('permission declined')
                    document.getElementById('qrcode-hint-no-video').innerHTML = '要掃描二維碼，請先同意使用裝置的攝影機功能。';
                })
            }
        }else{
            if(document.getElementById('reader').hasChildNodes()){
                document.getElementById('html5-qrcode-button-camera-stop').click();
            }
        }
    }
    $: check_reader_set(open);

    function onScanSuccess(decodedText, decodedResult) {
        if(decodedText.includes('https://dev.soofwood.com/nsed-audio-guide/?code') 
        || decodedText.includes('nsed.gov.hk/nsed-audio-guide/?code')
        || decodedText.includes('nsed.gov.hk/nsed-audio-guide/index.html?code')){
            let _code = decodedText.split('=')[1].replace('Z0','Z1');
            $code = _code;
            gtag('event', 'ag_scan', {
                'code': _code.replace('Z1AG1','Z0AG1') + $t('audio.suffix'),
            });
            close();
        }else{
            if(decodedText.startsWith("https://")){
                close();
                window.open(decodedText, '_blank');
            }
        }
    }

</script>

<div class="model-container {open?'open':''}">
    <Overlay _click={close}/>
    <div class='model-frame'>
        <div id='qrcode-content-wrapper' class='content-wrapper'>
            <div id='qrcode-hint-ins'>將二維碼對準在方框內</div>
            <div id='qrcode-permission-error'>
                <div id='qrcode-hint-no-video'>要掃描二維碼，請先同意使用裝置的攝影機功能。</div>
            </div>
            <div id='reader'></div>

            <div id='custom-reader-dashboard'>
                <div ></div>
            </div>

            <div class='qr-close-button' on:click={close}>關閉 Close</div>
        </div>
    </div>
</div>

<style lang="scss">
    .model-container{
        display: none;
        position: absolute;
        top: -1.1vh; /* idk why but this solves */
        left: 0;
        width: 100%;
        height: 100%;
        align-items: center;
        justify-content: center;
        z-index: 2;

        &.open{
            display: flex;
        }

        .model-frame{
            width: 100%;
            height: fit-content;
            max-height: 100svh;
            position: relative;
            background: url('../assets/images/model_frame.png');
            background-repeat: no-repeat;
            background-size: 100% 100%;
            background-position: center center;

            .content-wrapper{
                width: 80%;
                height: 95%;
                margin: 20px auto -4px;
                display: flex;
                row-gap: 4px;
                flex-direction: column;
                align-items: center;
                justify-content: center;
            }

            #reader{
                border: unset !important;
            }

            #qrcode-permission-error{
                display: flex;
                flex-direction: column;
                align-items: center;
                text-align: center;
                row-gap: 6px;
            }
        }
    }

    :global(#qrcode-content-wrapper:has(#reader__scan_region) #qrcode-permission-error){
        display: none !important;
    }
    :global(#qrcode-content-wrapper:not(:has(video)) #qrcode-hint-ins){
        display: none;
    }

    :global(#html5-qrcode-button-camera-stop),
    :global(#html5-qrcode-button-camera-start),
    .qr-close-button,
    .ask-permission-again{
        border-radius: 20px;
        background: linear-gradient(180deg, #004a8f 30% ,  #003366 70%);
        color: white;
        border: unset;
        padding: 2px 8px;
    }

    .qr-close-button{
        padding: 4px 14px;
        box-shadow: 1px 3px 5px 1px #00a8a8;
    }

    :global(#html5-qrcode-button-camera-stop::before){
        content: '停止掃描 ';
    }
    :global(#html5-qrcode-button-camera-start::before){
        content: '開始掃描 ';
    }
    :global(#reader__scan_region:has(video) ~ #reader__dashboard span:has(#html5-qrcode-select-camera)){
        display: none;
    }

    :global(span:has(#html5-qrcode-select-camera)::before){
        content: '選擇攝影鏡頭 ';
    }
    :global(#html5-qrcode-select-camera){
        margin: 4px;
    }

</style>